import React, { useState } from "react";
import { ApiPost } from "../../../service/ApiService";
import { Form, Button, Alert, Container } from "react-bootstrap";

const SmartBillCustomerImport = () => {
    const [file, setFile] = useState(null);
    const [uploadMessage, setUploadMessage] = useState("");
    const [error, setError] = useState(null);
    const [responseData, setResponseData] = useState(null); // Holds the response data
    const [showForm, setShowForm] = useState(true); // Controls form visibility

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleFileUpload = (e) => {
        e.preventDefault();

        if (!file) {
            setUploadMessage("Te rugăm să selectezi un fișier înainte de a-l încărca.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        ApiPost(
            "/api/smartbill/customer/import",
            formData,
            (response) => {
                setUploadMessage("Fișierul a fost încărcat cu succes!");
                setError(null);
                setResponseData(response); // Expected response payload from server
                setShowForm(false); // Hide the form after successful upload
            },
            (error) => {
                setError(
                    error.response?.data?.message ||
                    "A apărut o eroare în timpul încărcării fișierului."
                );
                setUploadMessage("");
                setResponseData(null);
            }
        );
    };

    return (
        <Container fluid className="mt-5">
            <h1>Import Clienți</h1>


            {/* Error Alert */}
            {error && (
                <Alert variant="danger">{error}</Alert>
            )}

            {/* File Upload Form */}
            {showForm && (
                <>
                    <p>
                        Încarcă un fișier Excel pentru a importa o listă de clienți. Fișierul trebuie să
                        conțină coloanele necesare: <strong>Denumire client, CIF, Reg. Com., Cod client, Adresă, Localitate, Județ, Bancă, IBAN, Țară, Email, Persoană de contact, Telefon</strong>.
                    </p>
                    <Form onSubmit={handleFileUpload} className="mb-4">
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label>Încarcă fișier Excel</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Încarcă
                        </Button>
                    </Form>
                </>
            )}

            {/* Upload Success Message */}
            {uploadMessage && (
                <Alert variant="info">
                    {uploadMessage}
                </Alert>
            )}

            {/* Display Import Summary using Alerts */}
            {responseData && !responseData.error && (
                <>
                    <h3>Rezumat Import</h3>
                    {responseData.counters.newItems > 0 && <Alert variant="success">
                        Clienti noi importati: {responseData.counters.newItems}
                    </Alert>}
                    {responseData.counters.updatedItems > 0 && <Alert variant="info">
                        Clienti actualizati: {responseData.counters.updatedItems}
                    </Alert>}
                    {responseData.counters.errorItems > 0 && <Alert variant="warning">
                        Clienti cu eroare: {responseData.counters.errorItems}
                    </Alert>}
                </>
            )}

            {/* Display Response Error Message */}
            {responseData && responseData.error && (
                <Alert variant="danger">
                    {responseData.errorMessage || "A apărut o eroare în timpul procesării fișierului."}
                </Alert>
            )}
        </Container>
    );
};

export default SmartBillCustomerImport;